module.exports = __webpack_public_path__ + "static/media/purchase_cap.5e416f7f.png";